import React from 'react'
import { map, times } from 'lodash'

import Column from './column'
import { Content, Name } from './elements'
import findLastChildren from './find-last-children'

const distributeInColumns = (items, numberOfColumns) => {
  const completeColumns = Math.floor(items.length % numberOfColumns)

  let nextIndex = 0

  const distribute = index => {
    const isCompleteColumn = index < completeColumns

    let size = Math.floor(items.length / numberOfColumns)

    if (isCompleteColumn) {
      size += 1
    }

    const columnItems = items.slice(nextIndex, nextIndex + size)

    nextIndex += size

    return columnItems
  }

  return times(numberOfColumns, distribute)
}

const Zone = props => {
  const { node, zoneIdToShow, onZoneClick } = props

  const coverage = findLastChildren(node)

  const coverageWithFourColumns = distributeInColumns(coverage, 4)

  const renderColumns = (column, index) => (
    <Column key={index} data={column} zoneIdToShow={zoneIdToShow} onZoneClick={onZoneClick} />
  )

  return (
    <ul>
      <Name>{node.name}</Name>
      <Content>{map(coverageWithFourColumns, renderColumns)}</Content>
    </ul>
  )
}

export default Zone
